import { useIntl } from 'react-intl';

import { useBasicInfo } from '@/components/_shared/contexts/BasicInfoContext';

import { getPanelDisplayPriceFromPriceInfo } from '../../utils';

export const useExternalTicketsHeadline = () => {
  const { formatMessage, locale } = useIntl();
  const { externalTicketing } = useBasicInfo();

  const externalTicketsUrl = externalTicketing?.externalTicketsUrl ?? '';
  const externalTicketsAreAvailable = externalTicketing?.externalTicketsAreAvailable ?? false;
  const externalTicketingProviderName = externalTicketing?.externalTicketingProviderName ?? '';

  if (!externalTicketsAreAvailable || !externalTicketsUrl) {
    return { headlineText: undefined, isExternalTicketingInformationAvailable: false };
  }

  const providerText = externalTicketingProviderName
    ? formatMessage(
        {
          id: 'On {provider}',
          defaultMessage: 'On {provider}',
          description: 'External ticketing provider label in the conversion bar',
        },
        { provider: externalTicketingProviderName },
      )
    : '';

  const priceText = getPanelDisplayPriceFromPriceInfo(
    {
      minimumTicketPrice: externalTicketing?.minimumTicketPrice,
      maximumTicketPrice: externalTicketing?.maximumTicketPrice,
      isFree: externalTicketing?.isFree,
    },
    locale,
    formatMessage,
  );

  const headlineText = [priceText, providerText].filter(Boolean).join(' · ');

  return { headlineText: headlineText || undefined, isExternalTicketingInformationAvailable: true };
};
